<template>
  <div>
    <v-alert
      :style="{
        'background-color': color,
        color: 'white',
      }"
      ><h5
        :style="{
          color: getSecondaryColor,
          textAlign: 'center',
        }"
      >
        {{ title }}
      </h5></v-alert
    >
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: "Title",
    },
    color: {
      default: "grey",
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
  },
};
</script>
